<script>
import Utils from '../Utils'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import Navbar from '../module/Navbar'


export default {
  name: "ParentMixin",
  components:{ 
    VueSlickCarousel,
    Navbar
  },
  data(){
    return {
      isMobile:false,
      settings: {
          "focusOnSelect": true,
          "infinite": false,
          "slidesToShow": 1,
          "variableWidth": true,
          "speed": 500,
          "initialSlide": 0,
          "arrow":false      
          // "responsive": [
          //             {
          //               "breakpoint": 6000,
          //               "settings": {
          //                 "centerMode": true,
          //                 "slidesToShow": 1,
          //                 "slidesToScroll": 3,
          //                 "initialSlide": 1,
          //                 "swipe":false
          //               }
          //             },
          //             {
          //               "breakpoint": 1023,
          //               "settings": {
          //                 "centerMode": false,
          //                 "slidesToShow": 1,
          //                 "initialSlide": 0,
          //                 "slidesToScroll": 1,
          //                 "swipe":true
          //               }
          //             }
          //           ]
      }       
    }
  },
  created (){
      this.isMobile = Utils.isMobile();
  },    
  methods : {

  },
}
</script>